// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2gD6I","large":"styles_large__Xi5k5"};